module.exports = __webpack_public_path__ + "img/home02.eab7fe39.png";